<!-- 商家中心 和 黄页详情有引用 -->
<template>
<div class="score-level">
    <div class="level-face">
        <template v-if="score>=4.5">
            <img :src="require('@/assets/images/info/comment-level-5.png')" alt="">
            很棒
        </template>
        <template v-else-if="score>=3.5">
            <img :src="require('@/assets/images/info/comment-level-4.png')" alt="">
             还可以
        </template>
        <template v-else-if="score>=2.5">
            <img :src="require('@/assets/images/info/comment-level-3.png')" alt="">
            一般
        </template>
        <template v-else-if="score>=1.5">
            <img :src="require('@/assets/images/info/comment-level-2.png')" alt="">
            较差
        </template>
        <template v-else>
            <img :src="require('@/assets/images/info/comment-level-1.png')" alt="">
            很糟糕
        </template>
    </div>
    <div class="score-star">
        <div class="score" v-for="index in 5" :key="index">
            <div class="lf" :class="{active:(2*index-1)*0.5<=score}" :title="(index*2+1)*0.5" ></div>
            <div class="lr" :class="{active:((2*index))*0.5<=score}" :title="(index*2+2)*0.5" ></div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name:'ShowCommentScore',
    props:{
        score:{
            type:Number,
            default:0
        }
    }
}
</script>
<style lang="scss" scoped>
.score-level{
    display: flex; align-items: center;
    .level-face{
        display: flex; margin-right: 10px; align-items: center; background: #ffe6e6; padding-right: 10px; border-radius: 10px; height: 20px;
        font-size: 12px; line-height: 20px; color: #D52B2B;
        img{width:20px; margin-right: 3px;}
    } 
}
.score-star{
    display: flex; align-items: center;
}
.score{
    position: relative;
    width: 20px; height: 20px; background: url('@/assets/images/info/comment-star.png') no-repeat center top ; background-size: 20px; margin-right: 2px;
    .lf,.lr{ position: absolute; top: 0; width: 50%; height: 100%; }
    .lf{left: 0;}
    .lr{right: 0;}
    .lr.active,.lf.active{
        background: url('@/assets/images/info/comment-star.png') no-repeat ; background-size:20px;
    }
    .lf.active{background-position: left bottom;}
    .lr.active{background-position: right bottom;}
}
</style>